import { render, staticRenderFns } from "./SearchForPostcards.vue?vue&type=template&id=109a7b66&"
import script from "./SearchForPostcards.vue?vue&type=script&lang=js&"
export * from "./SearchForPostcards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports